import "./dialog.scss";
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ErrorDialog = ({ open, onClose, errorMessage }) => {
  return (
    <Dialog open={open} onClose={onClose} className="dialog">
      <DialogTitle className="dialog-title">
        <span className="dialog-warning-icon">⚠️</span>
      </DialogTitle>
      <DialogContent className="dialog-content">
        {errorMessage}
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="contained" color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
